import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { QueryLoadingState } from '@globalconnect/query';
import { Observable, Subject, takeUntil } from 'rxjs';
import { configureFlexibleColumns } from '../../../../../installation-reporting-app/installation-reporting-wrapper/installation-reporting-table/table-columns/installation-reporting.columns.utils';
import {
  CombinedDeliveryInstallationData,
  InstallationReportOrderDetail,
  InstallationReportResponseV2,
} from '../../../../../shared/installation-report-content-v2/installation-report-content-entities';
import { InstallationReportFilterService } from '../../../../../shared/installation-report-content-v2/service/installation-report-filter.service';
import { isTopLevelDomainFI } from '../../../../../shared/util/deploy-helper';
import {
  MultiPointModalData,
  ReportModalService,
} from '../../../report-modal.service';

@Component({
  selector: 'app-hc-table',
  templateUrl: './hc-table.component.html',
  styleUrl: './hc-table.component.scss',
  standalone: false,
})
export class HcTableComponent implements OnInit, OnChanges, OnDestroy {
  @Output() dismiss = new EventEmitter();

  @Input() ifs: string;
  @Input() isLoading: boolean;
  @Input() multiPointData: MultiPointModalData;
  @Input() savedInstallationReportsResponse: QueryLoadingState<
    InstallationReportResponseV2[]
  >;
  @Input() set installationReports(
    installationReports: InstallationReportOrderDetail[],
  ) {
    this._installationReports = installationReports.filter(
      (installationReport) => installationReport.deliveryOrderId !== null,
    );
  }
  get installationReports() {
    return this._installationReports ?? [];
  }
  private _installationReports: InstallationReportOrderDetail[];

  tableData: InstallationReportOrderDetail[] = [];

  combinedDeliveryInstallationData$: Observable<
    CombinedDeliveryInstallationData[]
  >;

  isDeliveryPortalFI: boolean = isTopLevelDomainFI();
  cancelSubs$ = new Subject<void>();
  columns = configureFlexibleColumns(this.isDeliveryPortalFI ? 'FI' : 'SE');

  constructor(
    private filterService: InstallationReportFilterService,
    private reportModalService: ReportModalService,
    private changeDetector: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.setMultiPointTableData();
    this.combineDeliveryReportArrays();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.savedInstallationReportsResponse &&
      !changes.savedInstallationReportsResponse.isFirstChange()
    ) {
      this.combineDeliveryReportArrays();
      this.changeDetector.detectChanges();
    }
  }

  ngOnDestroy(): void {
    this.cancelSubs$.next();
    this.cancelSubs$.complete();
  }

  setMultiPointTableData() {
    this.multiPointData.data.hc.forEach((hc) =>
      this.installationReports.filter(
        (report) =>
          report.deliveryOrderId ===
            //revert this check to see data in FI locally.
            (this.isDeliveryPortalFI
              ? hc.properties.id
              : hc.properties.sourceKey) && this.tableData.push(report),
      ),
    );
  }

  combineDeliveryReportArrays(): void {
    if (this.savedInstallationReportsResponse.data) {
      this.combinedDeliveryInstallationData$ = this.filterService
        .combineDeliveryReportArrays$(
          this.tableData,
          this.savedInstallationReportsResponse.data,
        )
        .pipe(takeUntil(this.cancelSubs$));
    }
  }

  openInstallationReportModal(order: CombinedDeliveryInstallationData) {
    const address = `${order.orderDetail.locationInformation?.streetName} ${order.orderDetail.locationInformation?.postalCode} ${order.orderDetail.locationInformation?.city}`;
    this.closeModal();
    this.reportModalService.setModalState({
      ['installationReportModalV2']: {
        open: true,
        data: {
          sourceKey: order.orderDetail.deliveryOrderId ?? '',
          leadId: order.orderDetail.deliveryOrderId ?? '',
          name: address,
          id: order.orderDetail.id,
        },
        multiPoint: {
          ...this.multiPointData,
        },
      },
    });
  }

  closeModal() {
    this.dismiss.emit();
  }
}
